import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowUp, ArrowDown, Trash2, GripVertical } from "lucide-react";

export const BLOCK_LABELS = {
  hero: "Hero (naglowek + foto)",
  about: "O firmie",
  services: "Lista uslug / cennik",
  why_us: "Dlaczego warto",
  gallery: "Galeria zdjec",
  slotify: "Rezerwacja Slotify",
  parking_widget: "Widget rezerwacji parkingu",
  landing_premium: "Landing premium (hero + statystyki + atuty)",
  faq: "FAQ - pytania i odpowiedzi",
  whatsapp: "WhatsApp",
  opening: "Godziny otwarcia",
  contact: "Kontakt",
  map: "Mapa",
  cta: "CTA - wezwanie do dzialania",
  testimonials: "Opinie klientow",
  social: "Linki social media",
};

function summarize(block) {
  const d = block.data || {};
  switch (block.type) {
    case "hero":
      return d.title || "(brak tytulu)";
    case "about":
      return (d.body || "").slice(0, 60) || "(brak tresci)";
    case "services":
    case "why_us":
      return `${(d.items || []).length} pozycji`;
    case "gallery":
      return `${(d.photos || []).length} zdjec`;
    case "slotify":
      return d.slug ? `slug: ${d.slug}` : "(brak slug-a)";
    case "parking_widget":
      return d.widget_url ? "widget podlaczony" : "(brak widget_url)";
    case "landing_premium":
      return d.headline || "(brak naglowka)";
    case "faq":
      return `${(d.items || []).length} pytan`;
    case "whatsapp":
      return d.phone ? `tel: ${d.phone}` : "(uzyje telefonu firmy)";
    case "testimonials":
      return `${(d.items || []).length} opinii`;
    case "social":
      return [d.facebook, d.instagram, d.tiktok].filter(Boolean).length + " linkow";
    case "cta":
      return d.button_text || "(brak przycisku)";
    case "contact":
    case "opening":
    case "map":
      return "dane z karty firmy";
    default:
      return "";
  }
}

export default function BlockList({ blocks, selectedId, onSelect, onMove, onDelete }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Bloki strony</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {blocks.map((b, i) => {
          const active = selectedId === b.id;
          return (
            <div
              key={b.id}
              onClick={() => onSelect(b.id)}
              className={`flex items-center justify-between p-2 rounded-lg cursor-pointer border transition-colors ${
                active ? "border-emerald-500 bg-emerald-50/50" : "border-slate-200 hover:border-slate-300"
              }`}
            >
              <div className="flex items-center gap-2 min-w-0 flex-1">
                <GripVertical className="w-4 h-4 text-slate-300 flex-shrink-0" />
                <Badge variant="outline" className="text-xs flex-shrink-0">
                  {i + 1}
                </Badge>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-medium truncate">{BLOCK_LABELS[b.type] || b.type}</div>
                  <div className="text-xs text-slate-500 truncate">{summarize(b)}</div>
                </div>
              </div>
              <div className="flex items-center gap-0.5 flex-shrink-0">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onMove(i, -1);
                  }}
                  disabled={i === 0}
                  className="p-1 hover:bg-slate-100 rounded disabled:opacity-30"
                  aria-label="Przesun w gore"
                >
                  <ArrowUp className="w-3.5 h-3.5" />
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onMove(i, 1);
                  }}
                  disabled={i === blocks.length - 1}
                  className="p-1 hover:bg-slate-100 rounded disabled:opacity-30"
                  aria-label="Przesun w dol"
                >
                  <ArrowDown className="w-3.5 h-3.5" />
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(b.id);
                  }}
                  className="p-1 hover:bg-rose-100 hover:text-rose-600 rounded"
                  aria-label="Usun blok"
                >
                  <Trash2 className="w-3.5 h-3.5" />
                </button>
              </div>
            </div>
          );
        })}
        {blocks.length === 0 && (
          <p className="text-sm text-slate-500 text-center py-4">Brak blokow. Dodaj pierwszy lub wybierz szablon.</p>
        )}
      </CardContent>
    </Card>
  );
}
